// Runoff: houdt de keuze-samenvatting (blocks/rf-choice-summary.liquid) gelijk met de gekozen variant.
// Horizon stuurt bij elke keuze een 'variant:update'-event met de opnieuw gerenderde sectie;
// daaruit nemen we de nieuwe samenvatting over.
class RfChoiceSummary extends HTMLElement {
  connectedCallback() {
    this.target = this.closest('[id*="ProductInformation-"]') || document;
    this.target.addEventListener('variant:update', this.onVariantUpdate);
  }

  disconnectedCallback() {
    this.target?.removeEventListener('variant:update', this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    const data = event.detail?.data;
    if (!data?.html) return;
    if (data.productId && String(data.productId) !== this.dataset.productId) return;

    const fresh = data.html.querySelector(`#${CSS.escape(this.id)}`);
    if (fresh) this.innerHTML = fresh.innerHTML;
  };
}

if (!customElements.get('rf-choice-summary')) {
  customElements.define('rf-choice-summary', RfChoiceSummary);
}
